/**
 * Manages welcome screen session state.
 * Uses sessionStorage so the welcome animation shows once per login session.
 */

const WELCOME_KEY = "cradleOS_welcomeSeen";

export function hasSeenWelcome(): boolean {
  return sessionStorage.getItem(WELCOME_KEY) === "true";
}

export function markWelcomeAsSeen(): void {
  sessionStorage.setItem(WELCOME_KEY, "true");
}

export function clearWelcomeState(): void {
  sessionStorage.removeItem(WELCOME_KEY);
}
